import React, { useState } from 'react';


import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

export default function ListOption(props) {
    const [order, setOrder] = useState(0);
    const item = props.item;
    
    const arrow = (op) => {
        if(op === 1) return <FaArrowDown/>
        else return <FaArrowUp/> 
    }

    return(
        <button
            className={props.index === props.option ? 'selected':''}
            onClick={() => {
                if(props.index === props.option & props.isToOrder){
                    props.setOrderOption(Number(!order));
                    setOrder(Number(!order));
                } else {
                    props.setOption(props.index);
                    props.setOrderOption(Number(order));
                }
            }}
        >
            {item}
            {props.isToOrder ? arrow(order):[]}
        </button>
    )
}